<template>
    <v-card flat class="pa-2">

        <div class="pb-1">
            <span class="caption greyType--text">Import Progress</span>
        </div>

        <v-progress-linear
                :value="progressPercent"
                :indeterminate="foldersTotal <= 0"
                color="primary"
                height="8"
                class="ma-0"
        ></v-progress-linear>
        <div class="pt-1">
            <span class="body-1">{{ statusText }}</span>
        </div>

        <!--Counts-->
        <v-layout row wrap align-center class="pt-2">
            <v-flex shrink class="pr-2 pb-1">
                <v-chip small color="primary" text-color="white">
                    Folders: {{ foldersDone }} / {{ foldersTotal }}
                </v-chip>
            </v-flex>
            <v-flex shrink class="pr-2 pb-1">
                <v-chip small color="green" text-color="white">
                    {{ safeCounts.rowsImported }} rows imported
                </v-chip>
            </v-flex>
            <v-flex shrink class="pr-2 pb-1">
                <v-chip small color="grey" text-color="white">
                    {{ safeCounts.rowsPending }} pending
                </v-chip>
            </v-flex>
            <v-flex shrink class="pr-2 pb-1">
                <v-chip small color="blue-grey" text-color="white">
                    {{ safeCounts.rowsSkipped }} skipped
                </v-chip>
            </v-flex>
            <v-flex shrink class="pr-2 pb-1">
                <v-chip small :color="safeCounts.rowsError > 0 ? 'red' : 'grey'" text-color="white">
                    {{ safeCounts.rowsError }} row errors
                </v-chip>
            </v-flex>
            <v-flex shrink class="pr-2 pb-1" v-if="safeCounts.foldersError > 0">
                <v-chip small color="red" text-color="white">
                    {{ safeCounts.foldersError }} folder errors
                </v-chip>
            </v-flex>
        </v-layout>

        <div class="pt-2">
            <v-card flat class="pa-2" color="grey lighten-4">
                <v-layout row align-center>
                    <v-flex shrink class="pr-2">
                        <v-icon small color="primary">info</v-icon>
                    </v-flex>
                    <v-flex>
                        <span class="caption greyType--text">The import runs on the server - it is safe to close this dialog. You can reopen the run at any time from the History panel.</span>
                    </v-flex>
                </v-layout>
            </v-card>
        </div>

        <!--Cancel-->
        <v-layout row align-center class="pt-2">
            <template v-if="!confirmCancel">
                <v-flex shrink>
                    <v-btn
                            small
                            flat
                            color="red"
                            class="ma-0"
                            :disabled="cancelling || run.status != 'running'"
                            @click="confirmCancel = true"
                    >
                        <v-icon small left>cancel</v-icon>
                        Cancel Import
                    </v-btn>
                </v-flex>
            </template>
            <template v-else>
                <v-flex shrink>
                    <span class="caption red--text pr-2">Cancel this import? Folders already imported will be kept.</span>
                </v-flex>
                <v-flex shrink>
                    <v-btn
                            small
                            color="red"
                            dark
                            class="ma-0"
                            :loading="cancelling"
                            :disabled="cancelling"
                            @click="doCancel"
                    >
                        Yes, Cancel
                    </v-btn>
                </v-flex>
                <v-flex shrink class="pl-2">
                    <v-btn small flat color="grey" class="ma-0" :disabled="cancelling" @click="confirmCancel = false">
                        Keep Running
                    </v-btn>
                </v-flex>
            </template>
        </v-layout>
    </v-card>
</template>

<script>

    import {codeBaseMixin} from "../../codeBaseMixin";

    export default {
        mixins: [codeBaseMixin],
        props: {
            run: Object,
            counts: Object,
            cancelling: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                confirmCancel: false
            }
        },
        computed: {
            safeCounts() {
                return this.counts != null
                    ? this.counts
                    : {foldersTotal: 0, foldersDone: 0, foldersError: 0, rowsImported: 0, rowsError: 0, rowsSkipped: 0, rowsPending: 0};
            },
            foldersTotal() {
                return this.safeCounts.foldersTotal || 0;
            },
            foldersDone() {
                return this.safeCounts.foldersDone || 0;
            },
            progressPercent() {
                return this.foldersTotal > 0 ? (this.foldersDone / this.foldersTotal) * 100 : 0;
            },
            statusText() {
                if (this.run == null) {
                    return '';
                }
                if (this.run.status == 'running') {
                    return 'Importing folder ' + Math.min(this.foldersDone + 1, this.foldersTotal) + ' of ' + this.foldersTotal + '...';
                }
                return 'Run status: ' + this.run.status;
            }
        },
        methods: {
            doCancel() {
                this.confirmCancel = false;
                this.$emit('cancel-run');
            }
        }
    }
</script>

<style scoped>

</style>
